import styled from "styled-components";

export const PageSection = styled.div`
  display: block;
`;

export const PageTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.8rem;
  font-weight: bold;
`;

export const FilterTabs = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
  padding: 0.5rem;
  background: #2c2c2c;
  border-radius: 10px;
  border: 1px solid #333;
  overflow-x: auto;
  &::-webkit-scrollbar {
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #333;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ff6b35;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #e55a2b;
  }
`;

export const FilterTab = styled.button`
  background: ${(props) => (props.$active ? "#ff6b35" : "transparent")};
  color: ${(props) => (props.$active ? "#ffffff" : "#cccccc")};
  border: none;
  padding: 0.8rem 1.2rem;
  white-space: nowrap;
  border-radius: 8px;
  cursor: pointer;
  font-weight: ${(props) => (props.$active ? "bold" : "normal")};
  transition: all 0.3s ease;

  &:hover {
    background: ${(props) => (props.$active ? "#ff6b35" : "#333")};
    color: #ffffff;
  }
`;

export const ProductGrid = styled.div`
  column-width: 320px;
  margin-top: 1.5rem;
  columns: 5;
  column-gap: 1.5rem;

  @media (max-width: 2200px) {
    columns: 4;
  }
  @media (max-width: 1700px) {
    columns: 3;
  }
  @media (max-width: 1200px) {
    columns: 2;
  }
  @media (max-width: 768px) {
    column-width: 280px;
  }

  @media (max-width: 480px) {
    column-width: 100%;
    column-count: 1;
  }
`;

export const ProductActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  flex-wrap: wrap;
`;

export const Modal = styled.div`
  display: ${(props) => (props.$active ? "flex" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 2000;
  backdrop-filter: blur(5px);
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 2rem;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  border: 2px solid #ff6b35;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const ModalTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.5rem;
  font-weight: bold;
`;

export const ModalClose = styled.button`
  background: none;
  border: none;
  color: #ff6b35;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;

  &:hover {
    transform: rotate(90deg);
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

export const FormLabel = styled.label`
  display: block;
  color: #ff6b35;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 0.8rem;
  background: #333;
  border: 1px solid #555;
  border-radius: 8px;
  color: #ffffff;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }
`;
export const Relative = styled.div`
  position: relative;
`;

export const FormSelect = styled.select`
  width: 100%;
  padding: 0.8rem;
  background: #333;
  border: 1px solid #555;
  border-radius: 8px;
  color: #ffffff;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  padding: 0.8rem;
  background: #333;
  border: 1px solid #555;
  border-radius: 8px;
  color: #ffffff;
  transition: border-color 0.3s ease;
  resize: vertical;
  min-height: 100px;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }
`;

// Modal styles
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: #fff;
  border-radius: 50%;
  font-size: 1rem;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  -webkit-backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(4px);
  transition: background 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    color: #ff6b35;
  }
`;

export const ConfirmBox = styled.div`
  background: #1a1a1a;
  padding: 3rem 2rem;
  border-radius: 1.6rem;
  max-width: 400px;
  width: 100%;
  color: white;
  position: relative;
  text-align: center;

  h3 {
    font-family: "Poppins-SemiBold";
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: #ff6b35;
  }

  p {
    font-family: "Poppins-Medium";
    font-size: 1rem;
    margin-bottom: 2rem;
    color: #ccc;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

export const Cancel = styled.button`
  padding: 0.8rem 2rem;
  border-radius: 0.8rem;
  background: #333;
  color: white;
  border: none;
  font-family: "Poppins-SemiBold";
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    background: #444;
  }
`;

export const Confirm = styled.button`
  padding: 0.8rem 2rem;
  border-radius: 0.8rem;
  background: #ff6b35;
  color: white;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.65rem;
  font-size: 1rem;
  font-family: "Poppins-SemiBold";
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};

  &:hover {
    background: #ff6b35;
  }
`;

// Loading overlay
export const LoadingOverlay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #ff6b35;

  .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #333;
    border-top: 3px solid #ff6b35;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  p {
    font-size: 1.1rem;
    margin: 0;
  }
`;

// Error message
export const ErrorMessage = styled.div`
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid #e74c3c;
  color: #e74c3c;
  padding: 0.75rem;
  border-radius: 6px;
  margin-top: 0.5rem;
  font-size: 0.9rem;
`;

// Empty state
export const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  color: #888;

  h3 {
    color: #ccc;
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.5;
  }
`;

// Pagination container
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding: 1rem 0;
  border-top: 1px solid #333;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    align-items: center;
  }
`;

// Pagination info text
export const PaginationInfo = styled.div`
  color: #ccc;
  font-size: 0.9rem;
  min-width: 200px;

  @media (max-width: 768px) {
    order: 3;
    text-align: center;
    min-width: auto;
  }
`;

// Individual pagination button
export const PaginationButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 0.5rem;
  border: 1px solid #555;
  background: ${({ $active }) => ($active ? "#ff6b35" : "#333")};
  color: ${({ $active }) => ($active ? "#fff" : "#ccc")};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: ${({ $active }) => ($active ? "bold" : "normal")};
  font-size: 0.9rem;

  &:hover:not(:disabled) {
    background: ${({ $active }) => ($active ? "#e55a2b" : "#444")};
    border-color: ${({ $active }) => ($active ? "#e55a2b" : "#666")};
    color: #fff;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 107, 53, 0.3);
  }

  svg {
    font-size: 1rem;
  }
`;

export const SearchInput = styled.input`
  padding: 0.75rem 1rem;
  background: #333;
  border: 1px solid #555;
  border-radius: 6px;
  color: #fff;
  font-size: 0.9rem;
  width: 300px;
  transition: all 0.2s ease;

  margin-top: 1rem;
  &::placeholder {
    color: #888;
  }

  &:focus {
    outline: none;
    border-color: #ff6b35;
    box-shadow: 0 0 0 2px rgba(255, 107, 53, 0.2);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

// Search container
export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 300px;
  input {
    transition: all 0.2s ease;

    &:focus {
      border-color: #ff6b35;
      box-shadow: 0 0 0 2px rgba(255, 107, 53, 0.2);
    }
  }

  @media (max-width: 768px) {
    width: 100%;

    form {
      width: 100%;
      display: flex !important;
      gap: 0.5rem !important;
    }

    input {
      flex: 1;
      min-width: 0 !important;
    }
  }
`;

// Enhanced page header for better mobile layout
export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  gap: 2rem;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const Button = styled.button`
  padding: 0.8rem 1.2rem;
  min-height: 3rem;
  border: none;
  border-radius: 8px;
  width: fit-content;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: ${(props) => {
    switch (props.variant) {
      case "primary":
        return "#ff6b35";
      case "secondary":
        return "#666";
      case "danger":
        return "#e74c3c";
      case "success":
        return "#27ae60";
      default:
        return "#ff6b35";
    }
  }};
  color: #ffffff;

  &:hover:not(:disabled) {
    background: ${(props) => {
      switch (props.variant) {
        case "primary":
          return "#e55a2b";
        case "secondary":
          return "#555";
        case "danger":
          return "#c0392b";
        case "success":
          return "#229954";
        default:
          return "#e55a2b";
      }
    }};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

// Results counter
export const ResultsInfo = styled.div`
  color: #999;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  padding: 0.5rem 0;

  strong {
    color: #ff6b35;
  }
`;

// Zamenite postojeći NewsCard stil sa ovim u AdminNewsPage.styles.js

export const NewsCard = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  border-radius: 16px;
  padding: 1.8rem;
  border: 2px solid
    ${(props) =>
      props.$published ? "rgba(39, 174, 96, 0.3)" : "rgba(231, 76, 60, 0.3)"};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  break-inside: avoid;
  width: 100%;
  margin-bottom: 1.5rem;
  backdrop-filter: blur(10px);

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: ${(props) =>
      props.$published
        ? "linear-gradient(90deg, #27ae60, #2ecc71)"
        : "linear-gradient(90deg, #e74c3c, #c0392b)"};
    border-radius: 16px 16px 0 0;
  }

  &::after {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    width: 100%;
    height: 100%;
    background: ${(props) =>
      props.$published
        ? "radial-gradient(circle, rgba(39, 174, 96, 0.1) 0%, transparent 70%)"
        : "radial-gradient(circle, rgba(231, 76, 60, 0.1) 0%, transparent 70%)"};
    pointer-events: none;
    z-index: 0;
  }

  &:hover {
    transform: translateY(-8px) scale(1.02);
    border-color: ${(props) =>
      props.$published ? "rgba(39, 174, 96, 0.6)" : "rgba(231, 76, 60, 0.6)"};
    box-shadow: ${(props) =>
      props.$published
        ? "0px 20px 40px rgba(39, 174, 96, 0.25)"
        : "0px 20px 40px rgba(231, 76, 60, 0.25)"};
  }

  > * {
    position: relative;
    z-index: 1;
  }
`;

export const BadgeContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  flex-direction: row;
  margin-bottom: 1rem;
`;

export const NewsHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

export const NewsTitle = styled.h4`
  color: #fff;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
`;

export const NewsExcerpt = styled.p`
  color: #b8b8b8;
  margin: 1rem 0 1.5rem 0;
  line-height: 1.6;
  font-size: 0.95rem;
  opacity: 0.9;
  max-height: 4.8rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const NewsMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 1.5rem;
  font-size: 0.85rem;
`;

export const NewsBand = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #27ae60;
  font-weight: 500;
  transition: color 0.3s ease;
`;

export const NewsType = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ff6b35;
  font-weight: 600;
  padding: 0.4rem 0.8rem;
  background: rgba(255, 107, 53, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(255, 107, 53, 0.2);
  width: fit-content;
`;

export const NewsDate = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  color: #666;
  font-weight: 500;
  font-size: 0.85rem;
`;

export const Time = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #666;
  font-weight: 500;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  transition: color 0.3s ease;
`;

export const StatusBadge = styled.span`
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: bold;
  transition: all 0.3s ease;

  color: ${(props) => {
    switch (props.status) {
      case "completed":
      case "active":
        return "#27ae60";
      case "processing":
        return "#f39c12";
      case "inactive":
        return "#e74c3c";
      default:
        return "#cccccc";
    }
  }};
  background: ${(props) => {
    switch (props.status) {
      case "completed":
      case "active":
        return "rgba(39, 174, 96, 0.2)";
      case "processing":
        return "rgba(243, 156, 18, 0.2)";
      case "inactive":
        return "rgba(231, 76, 60, 0.2)";
      default:
        return "rgba(204, 204, 204, 0.2)";
    }
  }};

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;
